import { FunctionComponent } from 'react';
import { Checkbox, FormControlLabel, Grid, Typography } from '@mui/material';
import { FlexContainer, RowContainer } from '@/components/Layout/Container';
import { SectionTitle } from '@/components/Layout/Textual';
import { getTranslated } from '@/utils/translations';
import { locale } from '@/constants';
import { useAuthentication } from '@/hooks/useAuthentication';
import set from 'lodash/set';
import cloneDeep from 'lodash/cloneDeep';
import { ConfigurationCollection } from '@/models/bulkUpdate';
import { useGetLiftOperatorQuery } from '@/api/v2/liftOperator';
import { checkBoxTranslationsMap } from './bookingOptionsConfig';

const keys = ['keycard', 'barcode', 'pickup', 'internalProduction'];
const productionTypeKeysB2b = ['keycard', 'barcode', 'pickup'];

type BookingOptionsProps = {
    configurations: ConfigurationCollection;
    onChange: (newConfiguration: ConfigurationCollection) => void;
};

export const BookingOptions: FunctionComponent<BookingOptionsProps> = ({
    configurations,
    onChange,
}) => {
    const {
        liftOperatorData: { liftOperatorId },
    } = useAuthentication();
    const { data: liftOperator } = useGetLiftOperatorQuery({
        liftOperatorId: liftOperatorId,
    });

    const handleChange = (path) => (e) => {
        const { checked } = e.target;
        const configurationsCopy = cloneDeep(configurations);

        set(configurationsCopy, path, checked);

        onChange(configurationsCopy);
    };

    const productionTypeKeys = liftOperator?.mobileFlowEnabled
        ? [...keys, 'mobileFlow']
        : keys;

    return (
        <RowContainer>
            <Grid container spacing={3}>
                <Grid xs={12} md={3} item>
                    <FlexContainer column>
                        <Typography
                            sx={{
                                fontWeight: 600,
                            }}
                        >
                            Buchungsoption für Verkaufskanal:
                        </Typography>
                        <SectionTitle variant='subSection'>
                            {getTranslated('portalConfigurationTitle', locale)}
                        </SectionTitle>

                        {productionTypeKeys.map((key, i) => (
                            <FormControlLabel
                                key={i}
                                control={<Checkbox />}
                                onChange={handleChange(
                                    `portalConfiguration.${key}`
                                )}
                                label={getTranslated(
                                    checkBoxTranslationsMap[key],
                                    locale
                                )}
                            />
                        ))}
                    </FlexContainer>
                </Grid>

                <Grid xs={12} md={3} item>
                    <FlexContainer column>
                        <Typography
                            sx={{
                                fontWeight: 600,
                            }}
                        >
                            Buchungsoption für Verkaufskanal:
                        </Typography>
                        <SectionTitle variant='subSection'>
                            {getTranslated(
                                'integrationConfigurationTitle',
                                locale
                            )}
                        </SectionTitle>

                        {productionTypeKeys.map((key, i) => (
                            <FormControlLabel
                                key={i}
                                control={<Checkbox />}
                                onChange={handleChange(
                                    `integrationConfiguration.${key}`
                                )}
                                label={getTranslated(
                                    checkBoxTranslationsMap[key],
                                    locale
                                )}
                            />
                        ))}
                    </FlexContainer>
                </Grid>

                <Grid xs={12} md={3} item>
                    <FlexContainer column>
                        <Typography
                            sx={{
                                fontWeight: 600,
                            }}
                        >
                            Buchungsoption für Verkaufskanal:
                        </Typography>
                        <SectionTitle variant='subSection'>
                            {getTranslated('b2bConfigurationTitle', locale)}
                        </SectionTitle>

                        {productionTypeKeysB2b.map((key, i) => (
                            <FormControlLabel
                                key={i}
                                control={<Checkbox />}
                                onChange={handleChange(
                                    `b2bConfiguration.${key}`
                                )}
                                label={getTranslated(
                                    checkBoxTranslationsMap[key],
                                    locale
                                )}
                            />
                        ))}
                    </FlexContainer>
                </Grid>

                <Grid xs={12} md={3} item>
                    <FlexContainer column>
                        <Typography
                            sx={{
                                fontWeight: 600,
                            }}
                        >
                            Buchungsoption für Verkaufskanal:
                        </Typography>
                        <SectionTitle variant='subSection'>
                            {getTranslated(
                                'hospitalityConfigurationTitle',
                                locale
                            )}
                        </SectionTitle>

                        {productionTypeKeysB2b.map((key, i) => (
                            <FormControlLabel
                                key={i}
                                control={<Checkbox />}
                                onChange={handleChange(
                                    `hospitalityConfiguration.${key}`
                                )}
                                label={getTranslated(
                                    checkBoxTranslationsMap[key],
                                    locale
                                )}
                            />
                        ))}
                    </FlexContainer>
                </Grid>
            </Grid>
        </RowContainer>
    );
};
